module.exports = __webpack_public_path__ + "static/media/step2.7ac877d1.png";